<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Marke bearbeiten') }}</h1>
        </div>

        <p>
            <a :href="brand.permalink" target="_blank">{{ brand.permalink }}</a>
        </p>

        <div class="">
            <form @submit.prevent="form.put(route('admin.brands.update', brand))">
                <form-fields :form="form" :brand="brand" :countries="countries" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'brand',
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.brand.name,
                    slug: this.brand.slug,
                    meta_title: this.brand.meta_title,
                    meta_description: this.brand.meta_description,
                    description: this.brand.description,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>